import { Save } from 'lucide-react';
import type { FC, JSX } from 'react';
import Button from '../../shared/Button';
import FormField from '../../shared/FormField';
import Input from '../../shared/Input';
import Select from '../../shared/Select';

const GeneralSettingsTab: FC = (): JSX.Element => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6">General Settings</h2>

        <div className="space-y-6">
          <FormField label="Clinic Name">
            <Input type="text" defaultValue="Dental Care Clinic" />
          </FormField>

          <div className="grid grid-cols-2 gap-4">
            <FormField label="Time Zone">
              <Select defaultValue="America/Los_Angeles (PST)">
                <option>America/Los_Angeles (PST)</option>
                <option>America/New_York (EST)</option>
                <option>America/Chicago (CST)</option>
              </Select>
            </FormField>

            <FormField label="Default Language">
              <Select defaultValue="English">
                <option>English</option>
                <option>Spanish</option>
              </Select>
            </FormField>
          </div>

          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <div>
              <p className="font-medium text-gray-900">AI Agent Enabled</p>
              <p className="text-sm text-gray-600">Allow AI to book appointments and handle calls</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" defaultChecked className="sr-only peer" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
            </label>
          </div>

          <div className="flex justify-end pt-4 border-t border-gray-200">
            <Button leftIcon={<Save className="w-5 h-5" />} type="button">
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingsTab;
